import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';

@Directive({
  selector: '[appClickTrack]',
  standalone: true,
})
export class ClickTrackDirective {
  private analytics = inject(AnalyticsService);
  private el = inject(ElementRef);

  @Input() name: string;
  @Input() location: string;
  @Input() extra: { [key: string]: string | number | boolean };

  // listen to click events
  @HostListener('click', ['$event'])
  onClick() {
    this.analytics.track('button-clicked', false, { name: this.name, location: this.location, ...this.extra });
    const icon = this.getIcon();
    const text = this.el.nativeElement.textContent;
    this.analytics.setLastButtonClicked(this.name, text, icon, this.location);
  }

  private getIcon() {
    const icon1 = this.el.nativeElement.innerHTML.split('<app-svg')[1];
    if (!icon1) return;
    const icon2 = icon1.split('src="')[1];
    if (!icon2) return;
    const icon = icon2.split('"')[0];
    if (!icon) return;
    return icon.replace('/assets', '').replace('/icons', '');
  }
}
